<template>
  <AuthLayout :imageSrc="currentImage">
    <OTPVerification v-if="authStore.user.twoFactorEnabled" />
    <OTPRegistration v-else />
  </AuthLayout>
</template>

<script setup>
import OTPRegistration from "@/components/auth/OTP/OTPRegistration.vue";
import OTPVerification from "@/components/auth/OTP/OTPVerification.vue";
import AuthLayout from "@/layout/AuthLayout.vue";
import { useAuthStore } from "@/stores/authStore";
import currentImage from "@/assets/Images/OTP receiving.png";
const authStore = useAuthStore();
</script>
